import { action } from 'src/store/common';
import {
  AIChatClosePayload,
  AIChatConversationPayload,
  AIChatProgressClearPayload,
  AIChatProgressFinishPayload,
  AIChatSeedFailurePayload,
  AIChatSuccessPayload,
} from 'src/typings/ai-chat';
import { ProgressAdvance, ProgressStart } from './progress';

export const ActionTypes = {
  OPEN_CHAT: '[AI_CHAT]OPEN_CHAT',
  MINIMIZE_CHAT: '[AI_CHAT]MINIMIZE_CHAT',
  CLOSE_CHAT: '[AI_CHAT]CLOSE_CHAT',
  NEW_CHAT: '[AI_CHAT]NEW_CHAT',
  SET_DRAFT: '[AI_CHAT]SET_DRAFT',
  SEND_MESSAGE_REQUEST: '[AI_CHAT]SEND_MESSAGE_REQUEST',
  SEND_MESSAGE_SUCCESS: '[AI_CHAT]SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAILURE: '[AI_CHAT]SEND_MESSAGE_FAILURE',
  CONTEXT_LIMIT_REACHED: '[AI_CHAT]CONTEXT_LIMIT_REACHED',
  SEED_FAILED_MESSAGE: '[AI_CHAT]SEED_FAILED_MESSAGE',
  RETRY_LAST_MESSAGE: '[AI_CHAT]RETRY_LAST_MESSAGE',
  TOGGLE_MESSAGE_RESULTS: '[AI_CHAT]TOGGLE_MESSAGE_RESULTS',
  INVALIDATE_CONVERSATION: '[AI_CHAT]INVALIDATE_CONVERSATION',
  SET_CONVERSATION_ID: '[AI_CHAT]SET_CONVERSATION_ID',
  START_PROGRESS_TRACE: '[AI_CHAT]START_PROGRESS_TRACE',
  ADVANCE_PROGRESS_TRACE: '[AI_CHAT]ADVANCE_PROGRESS_TRACE',
  COMPLETE_PROGRESS_TRACE: '[AI_CHAT]COMPLETE_PROGRESS_TRACE',
  FAIL_PROGRESS_TRACE: '[AI_CHAT]FAIL_PROGRESS_TRACE',
  CLEAR_PROGRESS_TRACE: '[AI_CHAT]CLEAR_PROGRESS_TRACE',
};

export const openChat = action<void>(ActionTypes.OPEN_CHAT);
export const minimizeChat = action<void>(ActionTypes.MINIMIZE_CHAT);
export const closeChat = action<AIChatClosePayload>(ActionTypes.CLOSE_CHAT);
export const newChat = action<AIChatClosePayload>(ActionTypes.NEW_CHAT);
export const setDraft = action<string>(ActionTypes.SET_DRAFT);
export const sendMessageRequest = action<string>(ActionTypes.SEND_MESSAGE_REQUEST);
export const sendMessageSuccess = action<AIChatSuccessPayload>(ActionTypes.SEND_MESSAGE_SUCCESS);
export const sendMessageFailure = action<string>(ActionTypes.SEND_MESSAGE_FAILURE);
export const contextLimitReached = action<void>(ActionTypes.CONTEXT_LIMIT_REACHED);
export const seedFailedMessage = action<AIChatSeedFailurePayload>(ActionTypes.SEED_FAILED_MESSAGE);
export const retryLastMessage = action<void>(ActionTypes.RETRY_LAST_MESSAGE);
export const toggleMessageResults = action<string>(ActionTypes.TOGGLE_MESSAGE_RESULTS);
export const invalidateConversation = action<void>(ActionTypes.INVALIDATE_CONVERSATION);
export const setConversationId = action<string | AIChatConversationPayload>(
  ActionTypes.SET_CONVERSATION_ID,
);
export const startProgressTrace = action<ProgressStart>(ActionTypes.START_PROGRESS_TRACE);
export const advanceProgressTrace = action<ProgressAdvance>(ActionTypes.ADVANCE_PROGRESS_TRACE);
export const completeProgressTrace = action<AIChatProgressFinishPayload>(ActionTypes.COMPLETE_PROGRESS_TRACE);
export const failProgressTrace = action<AIChatProgressFinishPayload>(ActionTypes.FAIL_PROGRESS_TRACE);
export const clearProgressTrace = action<AIChatProgressClearPayload>(ActionTypes.CLEAR_PROGRESS_TRACE);
